import React from "react";
import PropTypes from 'prop-types';
import CONST from "../../config/CONST";
import {cashPriceProxy} from "../../classes/cashPriceProxy";
import {
    financialProductConfigurationPropTypesShape
} from "../../helpers/financialProductConfigurationHelpers";
import {useSelector} from "react-redux";
import {getAppData} from "../../store/slices/appSlice";
import {getSelectedCustomer} from "../../store/slices/userConfigurationsSlice";
import {useTranslation} from "react-i18next";

const VehicleDetails = (props) => {

    const {
        financialProductConfiguration,
        price,
        formatValue,
        cashPriceDisclaimer,
        isVehiclePriceVisible
    } = props;

    const { t } = useTranslation();

    const appData = useSelector(getAppData);
    const selectedCustomer = useSelector(getSelectedCustomer) || appData.touchpointConfig.defaults.customer;

    if(!appData || !financialProductConfiguration) {
        return null;
    }

    const dynamicCashPriceObject = new cashPriceProxy('cashPriceObject' + financialProductConfiguration.productTypeCode);

    const cashPrice = dynamicCashPriceObject.getCashPrice ({
        vehiclePrice: price,
        setVat: appData.touchpointConfig[selectedCustomer][financialProductConfiguration.productTypeCode] ? appData.touchpointConfig[selectedCustomer][financialProductConfiguration.productTypeCode].setVat : false,
        vatValue: appData.touchpointConfig.defaults.vatValue,
        BPM: financialProductConfiguration.BPM ? financialProductConfiguration.BPM : null
    });

    return (

        <div className={`${CONST.CSS_NAMESPACE}VehicleDetails`}>
                <div className={`${CONST.CSS_NAMESPACE}vehicleDescription`}>
                    <h1>{appData.input.brand + " " + appData.input.model + " "}</h1>
                    <h2>{appData.input.version}</h2>
                    <p>{appData.input.transmissionDescription + ", " + appData.input.fuelTypeDescription}</p>
                </div>

            { isVehiclePriceVisible &&
                <>
                <div className={`${CONST.CSS_NAMESPACE}vehiclePrice`}>
                    <div className={`${CONST.CSS_NAMESPACE}vehiclePriceLabel`}>
                        <p dangerouslySetInnerHTML={{__html: t(`Price_${selectedCustomer}`)}}/>
                    </div>
                    <div className={`${CONST.CSS_NAMESPACE}vehiclePriceValue`}>
                        <h2>{formatValue ? formatValue(cashPrice) : cashPrice.toString()}</h2>
                        <div className={`${CONST.CSS_NAMESPACE}disclaimerCashPrice`}>
                            <p dangerouslySetInnerHTML={{__html: cashPriceDisclaimer}}/>
                        </div>
                    </div>
                </div>
                </>
            }
        </div>

    );
}

VehicleDetails.propTypes = {
    financialProductConfiguration: PropTypes.shape(financialProductConfigurationPropTypesShape),
    price: PropTypes.number.isRequired,
    formatValue: PropTypes.func,
    cashPriceDisclaimer: PropTypes.string,
};

export default VehicleDetails;
